import Vue from "vue";
import App from "./App.vue";
import router from "./router"
import store from "./store"
import ElementUI from 'element-ui';
import './permission'
import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css'
import cv from "./components/calendar"
import cvHome from "./components/calendarHome"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import zyPagination from "common/zyPagination"
import zyButton from "common/zyButton"
import zySelect from "common/zySelect"
import zyUpload from "common/zyUpload"
import zyBigUpload from "common/zyBigUpload"
import zyDataPicker from "common/zyDataPicker"
import zyDialog from "common/zyDialog"
import zyEditor from "common/zyEditor"
import zyCardHeader from "common/zyCardHeader"
import VueLuckyCanvas from '@lucky-canvas/vue'
import zyCustomDrage from "common/zyCustomDrage"
import qrCode from 'common/qrCode'
import showShare from "common/showShare"
import questionDetail from 'questionnaire/questionDetail'
Vue.use(VueLuckyCanvas)
Vue.config.productionTip = false;
Vue.use(cv)
Vue.use(cvHome)
Vue.use(ElementUI)
Vue.component('ZyDataPicker',zyDataPicker)
Vue.component('ZyPagination',zyPagination)
Vue.component('ZyButton',zyButton)
Vue.component('ZySelect',zySelect)
Vue.component('ZyUpload',zyUpload)
Vue.component('ZyBigUpload',zyBigUpload)
Vue.component('ZyDialog',zyDialog)
Vue.component('ZyEditor',zyEditor)
Vue.component('ZyCardHeader',zyCardHeader)
Vue.component('ZyCustomDrage',zyCustomDrage)
Vue.component('QrCode',qrCode)
Vue.component('ZyQrCode',qrCode)
Vue.component('QuestionDetail',questionDetail)
Vue.prototype.$showShare = showShare
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);
Vue.use(VueAwesomeSwiper,/* {default global options} */)

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
import { isKeyName } from '@/utils/keyName.js'
Vue.prototype.isKeyName = isKeyName
import { isAuth } from '@/utils/isAuth.js'
Vue.prototype.isAuth = isAuth
// 全局注册图标
Vue.component('icon', Icon);
// 适配flex
import './utils/flexible.js';
//引入echart
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import {startIM} from "./IMmessage"
import IM from "./utils/im"
const wssUrl = process.env.NODE_ENV === "test"?'wss://ys.91boshuo.com/bim-wss/':process.env.NODE_ENV === "production"?`${process.env.BASE_URL?process.env.BASE_URL.replace('http','ws'):'wss://ys.91boshuo.com'}/bim-wss/`:'wss://ys.91boshuo.com/bim-wss/'
// const wssUrl = 'ws://jiuye.xjy.edu.cn:8092/bim-wss/';
console.log(wssUrl)
// const tim = new IM(wssUrl)
window.TIM = IM
// window.tim = tim
Vue.prototype.TIM = IM
// Vue.prototype.tim = tim
Vue.prototype.$bus = new Vue()
// startIM()

new Vue({
  name:'App',
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
